import HeroSection from "../../components/services/home/hero-section";
import ServicesSection from "../../components/services/home/services-section";
import AppShowcaseSection from "../../components/services/home/app-showcase-section";
import VideoSection from "../../components/services/home/video-section";
import TestimonialsSection from "../../components/services/home/testimonials-section";
import ContactSection from "../../components/services/home/contact-section";

const ServicesHomePage = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <AppShowcaseSection />
      <VideoSection />
      <TestimonialsSection />
      <ContactSection />
    </>
  );
};

export default ServicesHomePage;
